import { render, staticRenderFns } from "./Afiliado.vue?vue&type=template&id=6b84f188&scoped=true&"
import script from "./Afiliado.vue?vue&type=script&lang=js&"
export * from "./Afiliado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b84f188",
  null
  
)

export default component.exports